import React from "react";

import { Button, InputLabel } from '@mui/material';

export default function ColorFilterBox ({ colors, colorFilter, setColorFilter}) {
    return(
        <>
            <InputLabel>Filter By Color:</InputLabel>
            <Button
                key={`filter-color-none`}
                className="me-1"
                variant={colorFilter === "none" ? "contained" : "outlined"}
                onClick={(e) => setColorFilter("none")}
                color="Grey"
            >
                None
            </Button>
            {colors.map((value) => {
                return (
                    <Button
                        key={`filter-color-${value}`}
                        className="me-1"
                        variant={colorFilter === value ? "contained" : "outlined"}
                        onClick={(e) => setColorFilter(value)}
                        color={value}
                    >
                        {value}
                    </Button>
                )
              })
            }
        </>
    )
}